export function parseDate(val: any): Date | null {
  if (!val) return null;

  if (val instanceof Date) {
    return Number.isNaN(val.getTime()) ? null : val;
  }

  if (typeof val === 'string') {
    const trimmed = val.trim();
    const ddMmYyyy = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/);

    if (ddMmYyyy) {
      const day = Number.parseInt(ddMmYyyy[1], 10);
      const month = Number.parseInt(ddMmYyyy[2], 10);
      const yearPart = Number.parseInt(ddMmYyyy[3], 10);
      const year = yearPart < 100 ? 2000 + yearPart : yearPart;
      const parsed = new Date(year, month - 1, day, 0, 0, 0, 0);

      if (
        parsed.getFullYear() === year &&
        parsed.getMonth() === month - 1 &&
        parsed.getDate() === day
      ) {
        return parsed;
      }
    }
  }
  try {
    const timestamp = Date.parse(val);
    return timestamp > 0 ? new Date(timestamp) : null;
  } catch {
    return null;
  }
}
